module.exports = __webpack_public_path__ + "media/components/lessons/statics/lesson2-cddbe178a959be211590c0c29ae77947.gif";